export class KilometerMilesCalculate {
  static calculateToMiles(kilometers: number): number {
    return kilometers / 1.60934;
  }
  static calculateToKilometers(miles: number): number {
    return miles * 1.60934;
  }
}
